import React, { FC } from 'react';

import Decline from './atoms/Decline';
import Restrictions from './atoms/Restrictions';

import styles from './index.module.sass';

interface FooterProps {
  step: number;
  onDecline: () => void;
}

const Footer: FC<FooterProps> = ({ step, onDecline }) => (
  <div className={styles.container}>
    <Decline onClick={onDecline} />

    <Restrictions step={step} />
  </div>
);

export default Footer;
